





import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({})
export default class StartPage extends Vue {
  @Prop({ default: '' }) start_pic_url: string
}
